<template>
  <button
    class="group border-bdr-subtle bg-bgr-primary hover:bg-bgr-secondary flex w-full items-center gap-4 rounded-lg border px-4 py-2 text-left hover:border-1"
    type="button"
  >
    <div class="flex w-full gap-3 overflow-hidden">
      <div class="text-body-default overflow-hidden font-medium text-nowrap text-ellipsis">
        {{ group.label }}
      </div>
      <Badge :variant="BadgeVariant.Default" :strong="false">{{ group.printers.length }}</Badge>
    </div>
    <div class="ml-auto">
      <Icon src="arrow_right" />
    </div>
  </button>
</template>

<script setup lang="ts">
  import type { IPrinterGroup } from "~/types/printer";

  defineProps<{
    group: IPrinterGroup;
  }>();
</script>
